import { useState, useEffect, useCallback } from 'react';
import { getPerformanceStatus } from '../store/api';

const usePerformanceStatus = (pollInterval = 5 * 1000) => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchPerformanceStatus = useCallback(async () => {
    try {
      setLoading(true);
      
      try {
        const data = await getPerformanceStatus();
        setStatus(data?.result);
      } catch (apiError) {
        setStatus(null);
      }
    } catch (err) {
      setStatus(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPerformanceStatus();
    const interval = setInterval(fetchPerformanceStatus, pollInterval);
    return () => clearInterval(interval);
  }, [fetchPerformanceStatus, pollInterval]);

  return {
    status,
    loading
  };
};

export default usePerformanceStatus;
